import JobsLayout from "../components/tasks/JobsLayout.vue";
import Overview from "../components/tasks/Overview.vue";
const List = () => import("../components/tasks/List.vue");
const TimeCards = () => import("../components/tasks/TimeCards.vue");
const Leaderboard = () => import("../components/tasks/Leaderboard.vue");
const Pipeline = () => import("../components/tasks/Pipeline.vue");
// @ts-ignore
import store from "../store";
const resetStore = (to, from, next) => {
    store.dispatch('dataView/hardReset');
    next();
};
let children = [
    {
        name: 'jobs.overview',
        path: 'overview',
        component: Overview,
        children: [
            {
                name: 'jobs.new',
                path: 'new',
                component: Overview
            },
        ]
    }
];
if (window.marque.ui.features.prep.pipeline.enabled) {
    children.push({
        name: 'jobs.pipeline',
        path: 'pipeline',
        component: Pipeline,
        beforeEnter: resetStore
    });
}
children.push({
    name: 'jobs.list',
    path: 'list',
    component: List,
    beforeEnter: resetStore
}, {
    name: 'jobs.timecards',
    path: 'timecards',
    component: TimeCards,
    beforeEnter: resetStore
}, {
    name: 'jobs.leaderboard',
    path: 'leaderboard',
    component: Leaderboard,
    beforeEnter: resetStore
});
const routes = {
    path: '/jobs',
    component: JobsLayout,
    children
};
export default routes;
